import getAttribute from './getAttribute';

const GENDER_MAP = {
    Man: 'mens',
    Woman: 'womens',
};

export const getGender = (value) => GENDER_MAP[value];

export const getGenderFromAttributes = (attributes) => getGender(getAttribute(attributes, 'Gender'));

export default getGender;
